import { Car, Bike, Footprints } from "lucide-react";

export const MODES = [
  { id: "car", label: "Auto", icon: Car, color: "#1A2A6C" },
  { id: "bike", label: "Bici", icon: Bike, color: "#26B5A8" },
  { id: "walk", label: "A piedi", icon: Footprints, color: "#FF9E1B" },
];

export function modeOf(id) {
  return MODES.find((m) => m.id === id) || MODES[0];
}

export default function ModePicker({ value, onChange, disabled = false }) {
  return (
    <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Modalità di trasporto" data-testid="mode-picker">
      {MODES.map(({ id, label, icon: Icon, color }) => {
        const active = value === id;
        return (
          <button
            type="button"
            key={id}
            onClick={() => !disabled && onChange(id)}
            disabled={disabled}
            aria-pressed={active}
            className={`px-2 py-3 rounded-2xl border-2 transition-all flex flex-col items-center gap-1.5 ${
              active
                ? "border-[#1A2A6C] bg-[#F5F6FA] shadow-[0_4px_12px_rgba(26,42,108,0.12)]"
                : "border-[#ECEEF5] bg-white hover:bg-[#F8F9FC]"
            } ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}
            data-testid={`mode-${id}`}
          >
            <Icon className="w-5 h-5" style={{ color }} />
            <span className="text-sm font-semibold text-[#1A1D29]">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
